import React from 'react'
import { Redirect, useHistory, useLocation, useParams } from 'react-router-dom'

import { Icon, palette } from '@centivo/react-components'
import {
  ProviderProfilePage,
  useProviderProfilePage,
} from '@centivo/provider-directory-components'

import { useDirectoryAdapter } from 'src/refactor/hooks'
import { useGlobalState } from 'src/context/global'
import { MEMBER_PORTAL_SIGN_IN_URL } from 'src/refactor/helpers/constants'
import {
  buildProfileLocation,
  parseProfileSearch,
} from 'src/refactor/helpers/profileNavigation'

import { StyledProviderProfilePage } from './PractitionerDetails.styled'

export const PractitionerDetails: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const { search } = useLocation()
  const history = useHistory()
  const { fetchParams, distance, placeId } = parseProfileSearch(search)
  const { directoryAdapter, mapboxAccessToken } = useDirectoryAdapter()
  const [{ appConfig }] = useGlobalState()
  const { displayPcpActivationBadge, displayReferralRequiredBadge } = appConfig

  const { providerProfilePage } = useProviderProfilePage({
    entityType: 'practitioner',
    entityId: id ?? '',
    distance,
    fetchParams,
    fetchProviderDetail: directoryAdapter.fetchProviderDetail,
    fetchInstitutionDetail: directoryAdapter.fetchInstitutionDetail,
    fetchProviderLocations: placeId
      ? (provider, context) =>
          directoryAdapter.searchProviderLocations(provider, {
            signal: context.signal,
            placeId,
            distance: context.distance,
            fetchParams: context.fetchParams,
          })
      : undefined,
    fetchInstitutionProviders: directoryAdapter.fetchInstitutionProviders,
    mapboxAccessToken,
    guestSignInHref: MEMBER_PORTAL_SIGN_IN_URL,
    displayPcpActivationBadge,
    displayReferralRequiredBadge,
    onSelectProvider: providerId =>
      history.push(
        buildProfileLocation('doctor', providerId, { fetchParams, placeId })
      ),
  })

  if (!id) return <Redirect to="/results" />

  return (
    <main>
      <StyledProviderProfilePage>
        <button className="back-button" type="button" onClick={history.goBack}>
          <Icon icon="arrow-left" color={palette.brand.brown} size="1.5rem" />
          <h3>Back</h3>
        </button>
        <ProviderProfilePage {...providerProfilePage} />
      </StyledProviderProfilePage>
    </main>
  )
}
